import { AppVersionVo } from '../models/app-version-vo';
import { DateVo } from '../models/date-vo';
import { MultiTemplateModel } from '../models/multi-template-model';
import { SuitablePhotosCountVo } from '../models/suitable-photos-count-vo';
import { TemplatePageVo } from '../models/template-page-vo';
import { TemplateDto } from './template-dto';

export type MultiTemplateDto = TemplateDto & {
  pages_info: { template_id: number; thumbnail_url: string }[];
};

export const parseMultiTemplateDto = (dto: MultiTemplateDto): MultiTemplateModel => {
  return MultiTemplateModel.create(
    dto.id,
    dto.author,
    dto.uploader_info,
    dto.source_url,
    dto.is_vip,
    dto.is_animated,
    dto.image_url,
    dto.animated_thumbnail_url,
    dto.size_category,
    dto.slots_count,
    dto.creator_id || null,
    DateVo.parseTimeString(dto.created_at),
    DateVo.parseTimeString(dto.updated_at),
    dto.is_multipage,
    dto.is_adjustable,
    SuitablePhotosCountVo.create(dto.lower_suitable_photos_count, dto.upper_suitable_photos_count),
    dto.labels,
    dto.minimal_required_version_ios
      ? AppVersionVo.create(
          dto.minimal_required_version_ios[0] || 0,
          dto.minimal_required_version_ios[1] || 0,
          dto.minimal_required_version_ios[2] || 0,
        )
      : null,
    dto.minimal_required_version_android
      ? AppVersionVo.create(
          dto.minimal_required_version_android[0] || 0,
          dto.minimal_required_version_android[1] || 0,
          dto.minimal_required_version_android[2] || 0,
        )
      : null,
    dto.template_tag_ids,
    false,
    null,
    null,
    [],
    dto.suits_video,
    dto.pages_info.map((page_info) => TemplatePageVo.create(page_info.template_id, page_info.thumbnail_url)),
    dto.pages_info.map((page_info) => page_info.template_id),
  );
};
